export enum PasswordExpiryEnum {
  PrePasswordExpired = 'PrePasswordExpired',
  ResetPasswordConfirmation = 'ResetPasswordConfirmation',
  PostPasswordExpired = 'PostPasswordExpired',
}
